import { render, staticRenderFns } from "./shortcuts.vue?vue&type=template&id=2bf53814&lang=pug&"
import script from "./shortcuts.vue?vue&type=script&lang=coffee&"
export * from "./shortcuts.vue?vue&type=script&lang=coffee&"
import style0 from "./shortcuts.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports